module.exports = __webpack_public_path__ + "images/carrot.49c565dd.svg";